import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
class DeleteItemCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  Submit = () => {
    let id = this.props.DeleteitemCategoryItem && this.props.DeleteitemCategoryItem.id;

    this.props.DeleteItemCategory(id);
    this.props.closeitemCategoryDelModel();
    this.props.resetPage();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showitemCategoryDelModel}
          animation={false}
          size="md"
          backdrop="static"
          onHide={this.props.closeitemCategoryDelModel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Delete Item Category</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Are you sure you want to delete?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  className="cmnDelCnclBtn"
                  variant="danger"
                  onClick={() => this.props.closeitemCategoryDelModel()}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DeleteItemCategory;
